export default "__VITE_ASSET__LyugPFG4__"